module.exports = __webpack_public_path__ + "img/branch-chongqing.8134529e.jpg";